import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PROMOS_QUERY_KEY} from "../queryKeys";
import {ReachPromo, ReachPromoPayload} from "./types";

type UpdatePromoVariables = {id: number; payload: ReachPromoPayload};

const updatePromo = async ({id, payload}: UpdatePromoVariables): Promise<ReachPromo> => {
  const response = await axiosReachInstance.put<ReachPromo, AxiosResponse<ReachPromo>, ReachPromoPayload>(
    `/promos/${id}`,
    payload
  );
  return response.data;
};

export const useUpdatePromo = (
  options?: BaseMutationOptions<ReachPromo, UpdatePromoVariables>
): BaseUseMutationResult<ReachPromo, UpdatePromoVariables> => {
  return useBaseMutation<ReachPromo, UpdatePromoVariables>(updatePromo, {
    ...options,
    prefixKeysToInvalidate: () => [[PROMOS_QUERY_KEY]],
  });
};
